import { render, staticRenderFns } from "./AsideLinhaDoTempo.vue?vue&type=template&id=065fd6ba&scoped=true&lang=pug"
import script from "./AsideLinhaDoTempo.vue?vue&type=script&lang=js"
export * from "./AsideLinhaDoTempo.vue?vue&type=script&lang=js"
import style0 from "./AsideLinhaDoTempo.styl?vue&type=style&index=0&id=065fd6ba&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fd6ba",
  null
  
)

export default component.exports